import apiClient from "./axiosConfig";

export const sendAskAstroAction = async (tgId: number) => {
  return apiClient.post("api/webhooks/from-webapp", {
    action: "ask_astro",
    tg_id: tgId,
  });
};
